import { z } from "zod";
import { FROM, TO } from "./consts";

export const schema = z.object({
  [FROM]: z.string().min(1, "This Field is required"),
  [TO]: z.string().min(1, "This Field is required"),
});

export type formValues = z.infer<typeof schema>;